function readCssColor(varName) {
  if (typeof document === 'undefined') return 'transparent';
  const v = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
  return v || 'transparent';
}

function triggerDownload(href, fileName) {
  const a = document.createElement('a');
  a.href = href;
  a.download = fileName;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function buildCsv(xAxisData, seriesData) {
  const header = ['Category', ...seriesData.map((s) => s.name)];
  const lines = [header.join(',')];
  for (let i = 0; i < xAxisData.length; i += 1) {
    const row = [
      typeof xAxisData[i] === 'number'
        ? String(xAxisData[i])
        : `"${String(xAxisData[i]).replace(/"/g, '""')}"`,
      ...seriesData.map((s) => {
        const v = s.data?.[i];
        return v == null || Number.isNaN(Number(v)) ? '' : String(v);
      }),
    ];
    lines.push(row.join(','));
  }
  return lines.join('\n');
}

/**
 * Execute a chart download.
 * - format: 'png' | 'svg' | 'csv'
 * - getEchartsInstance must return an ECharts instance with getDataURL()
 */
export function executeChartDownload(opts) {
  const { format, fileName, getEchartsInstance, xAxisData, seriesData } = opts || {};
  const chart = typeof getEchartsInstance === 'function' ? getEchartsInstance() : null;

  if (format === 'csv') {
    const csv = buildCsv(xAxisData || [], seriesData || []);
    const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    triggerDownload(url, `${fileName}.csv`);
    URL.revokeObjectURL(url);
    return;
  }

  if (!chart || typeof chart.getDataURL !== 'function') return;

  const bg = readCssColor('--background-neutral-primary');
  if (format === 'png' || format === 'svg') {
    const type = format;
    const dataUrl = chart.getDataURL({
      type,
      pixelRatio: type === 'png' ? 2 : 1,
      backgroundColor: bg,
    });
    triggerDownload(dataUrl, `${fileName}.${type}`);
  }
}

